import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { KeyboardModule } from '@qtek/libs/keyboard';
import { PermissionDirective } from '@qtek/libs/permissions';
import { TranslationCoreModule } from '@qtek/libs/translation-core';
import { ChatComponent, KeyboardSwitchComponent } from '@qtek/libs/ui';
import { WsErrorHandlerModule } from '@qtek/libs/ws-error-handler';

import { HealthcheckCoreModule } from '@qtek/libs/healthcheck-core';
import * as fromComponent from './components';
import { AvatarMenuComponent } from './components';
import * as fromGuards from './guards';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    KeyboardModule,
    WsErrorHandlerModule,
    TranslationCoreModule,
    MatBadgeModule,
    MatToolbarModule,
    MatSidenavModule,
    MatMenuModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatTooltipModule,
    MatCardModule,
    MatListModule,
    KeyboardSwitchComponent,
    HealthcheckCoreModule,
    ChatComponent,
    PermissionDirective,
    ...fromComponent.standaloneComponents,
  ],
  declarations: [...fromComponent.components],
  providers: [...fromGuards.guards],
  exports: [AvatarMenuComponent],
})
export class LayoutModule {}
